import React from 'react';
import { Booking, Service, Addon } from '../types/booking.types';
import CustomerDetailsCard from './CustomerDetailsCard';
import AddressCard from './AddressCard';
import PaymentSummaryCard from './PaymentSummaryCard';
import BookingMetadata from './BookingMetadata';

interface SummaryTabProps {
  booking: Booking;
  additionalServices?: Service[];
}

const SummaryTab: React.FC<SummaryTabProps> = ({ booking, additionalServices = [] }) => {
  const toNumber = (value: number | string | null | undefined) => {
    const parsed = parseFloat(String(value ?? 0));
    return Number.isNaN(parsed) ? 0 : parsed;
  };

  const additionalTotals = additionalServices.reduce(
    (acc, service) => {
      const addons: Addon[] = Array.isArray(service.addons) ? service.addons : [];
      const serviceAmount = toNumber(service.amount);
      const serviceCgst = toNumber(service.cgst_amount);
      const serviceSgst = toNumber(service.sgst_amount);
      const serviceTotal = toNumber(service.total_amount) || serviceAmount + serviceCgst + serviceSgst;

      const addonAmounts = addons.reduce((sum, addon) => sum + toNumber(addon.amount), 0);
      const addonCgst = addons.reduce((sum, addon) => sum + toNumber(addon.cgst_amount), 0);
      const addonSgst = addons.reduce((sum, addon) => sum + toNumber(addon.sgst_amount), 0);
      const addonTotals = addons.reduce(
        (sum, addon) => sum + (toNumber(addon.total_amount) || toNumber(addon.amount) + toNumber(addon.cgst_amount) + toNumber(addon.sgst_amount)),
        0
      );

      acc.subtotal += serviceAmount + addonAmounts;
      acc.cgst += serviceCgst + addonCgst;
      acc.sgst += serviceSgst + addonSgst;
      acc.total += serviceTotal + addonTotals;
      return acc;
    },
    { subtotal: 0, cgst: 0, sgst: 0, total: 0 }
  );

  return (
    <div className="mb-6">
      {/* Booking Metadata */}
      <BookingMetadata booking={booking} />
      
      {/* Customer & Address Info - Compact Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <CustomerDetailsCard booking={booking} />
        <AddressCard booking={booking} />
        <PaymentSummaryCard booking={booking} additionalTotals={additionalTotals} />
      </div>
    </div>
  );
};

export default SummaryTab;
